import React from "react"
import { Link } from "gatsby"
import Img from 'gatsby-image'

const CaseStudyCard = ({ caseStudy }) => {
  return (
    <section className="sm:flex sm:mb-24" key={caseStudy.slug}>
      <div className="hidden sm:block sm:w-5/12 sm:flex sm:flex-col sm:justify-center">
        <h2 className="text-gondola py-4">
          {caseStudy.title}
        </h2>
        <div className="w-9/12">
          {caseStudy.description}
        </div>
        <Link to={caseStudy.path}
          className="text-btn py-1 px-2 my-8 border border-current text-gondola hover:bg-au_chico hover:text-white hover:border-transparent rounded flex items-center justify-center w-2/5">
          <span>Explore case study</span>
        </Link>
      </div>
      <Link to={caseStudy.path} className="block sm:w-7/12 sm:h-full">
        {caseStudy.image != null && <Img fadeIn={false} fluid={caseStudy.image.childImageSharp.fluid} />}
      </Link>
      <div className="sm:hidden">
        <h2 className="text-gondola py-4">
          {caseStudy.title}
        </h2>
        <div>
          {caseStudy.description}
        </div>
        <Link to={caseStudy.path}
          className="text-btn py-1 px-2 my-8 border border-current text-gondola hover:bg-au_chico hover:text-white hover:border-transparent rounded flex items-center justify-center">
          <span>Explore case study</span>
        </Link>
      </div>
    </section>
  )
}

export default CaseStudyCard